<template>
  <div>
    <div
      class="pb-3"
      style="max-height: 65vh;overflow-y:auto;"
    >
      <div class="container py-3 d-flex align-items-center flex-column">
        <h5 class="font-16">キャリア登録を希望する企業を選択してください</h5>
        <div class="d-flex justify-content-center align-items-center">
          <input
            class="custom-checkbox mr-3"
            type="checkbox"
            v-model="selectAllCompaniesModel"
            id="select_all"
            name="select_all"
          />
          <label
            class="form-check-label font-16"
            for="select_all"
            style="padding-top: 3px"
          >
            すべて選択（全{{ companies.length }}社）
          </label>
        </div>
        <div class="companiesList">
          <div class="col-lg-12 mb-30 py-2">
            <!--even-->
            <div class="row">
              <div
                class="col-lg-6 col-md-6 py-1 border"
                v-for="(company, index) in companies"
                v-bind:key="company._id"
              >
                <div 
                  class="d-flex justify-content-between font-14"
                  v-b-toggle="`accordino0_${index}`"
                  style="cursor: pointer;"
                >
                  <div class="d-flex align-items-center">
                    <div style="height: 20px; width: 20px;" class="mr-3">
                      <input
                        class="custom-checkbox"
                        type="checkbox"
                        :id="company._id"
                        :value="company._id"
                        name="other_companies"
                        v-model="other_companies"
                      />
                    </div>
                    <label
                      class="form-check-label font-14"
                      style="padding-top: 3px;"
                    >
                      {{ company.name }}
                    </label>
                  </div>
                  <div>
                    <i
                      class="fa fa-chevron-down"
                      aria-hidden="true"
                      style="height: 100%"
                    ></i>
                  </div>
                </div>
                <div>
                  <b-collapse
                    class="py-1"
                    v-bind:id="`accordino0_${index}`"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card>
                      <span v-html="urlify(company.short_description)"> </span>
                    </b-card>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stickyFooter">
      <div
        class="py-sm-3 py-2 pb-sm-4 w-100 bg-white d-flex justify-content-center"
      >
        <button
          @click="handleExitWithoutSelection"
          class="d-inline-flex align-items-center text-gray pt-sm-0 pt-2"
          style="background: #fff; border: none;"
          >選択せず終了する</button>
        
        <button
          class="btn text-white btn-sm py-2 px-5 rounded mx-5 custom-btn confirmBtn"
          @click="confirm"
        >
          企業登録に進む
        </button>
      </div>
    </div>

    <b-modal
      ref="confirmModal"
      hide-header
      hide-footer
      centered
      size="lg"
      @hidden="hideModal"
    >
      <div class="swal-title mt-4" style="color:#000">
        以下企業へキャリア登録しますか？
      </div>
      <div class="rounded text-left p-4" style="background: #dee9f5;">
          <p class="notice-list-header"
          >
          直近在籍企業など、あなたの情報を公開したくない企業が含まれていないか十分注意してください。
            <!-- ご自身の在籍企業など、情報を公開したくない企業が含まれていないか十<span>分注意してください。</span> -->
          </p>
          <br />
          <ul class="notice-list">
            <li>
              あなたのキャリア登録情報が企業へ公開されます。
            </li>
            <li>
              企業側はあなたが他にキャリア登録している企業を知ることはできません。
            </li>
            <li>
              許諾無しにあなたがキャリア登録していない企業へ情報が公開されることはありません。
            </li>
          </ul>
      </div>
      <div class="swal-content mt-1">
        <div class="mx-md-5 p-3 d-flex flex-column">
          <span
            class="swal-text m-0 swal-font mb-2"
            style="color:#000"
            v-for="name in selectedCompanyName"
            >{{ name }}</span
          >
        </div>
      </div>
      <div
        class="swal-footer d-flex justify-content-center custom-modal-footer full"
      >
        <button
          class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-14 font-bold cancelBtn w-230"
          @click="shareCompanyResponse(false)"
        >
          企業選択に戻る
        </button>
        <button
          class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-12 text-center confirmBtn w-230"
          @click="shareCompanyResponse(true)"
        >
          注意事項に同意して <br />
          <span class="font-bold font-14">登録する</span>
        </button>
      </div>
      <div
        class="swal-footer d-flex justify-content-center custom-modal-footer mobile"
      >
        <button
          class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-12 text-center confirmBtn w-230 mb-2"
          @click="shareCompanyResponse(true)"
        >
          <span style="font-size:14px">注意事項に同意して</span> <br />
          <span class="font-bold font-18">登録する</span>
        </button>
        <button
          class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-14 cancelBtn w-230"
          @click="shareCompanyResponse(false)"
        >
          企業選択に戻る
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Api from '@/config/api';
import swal from 'sweetalert';
import logo from '../assets/Group300.png';

export default {
  name: 'CompaniesList',
  props: {
    companies: {
      type: Array,
      required: true
    },
    companyData: {
      type: Object,
      default: null
    },
    token: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectAllCompaniesModel: false,
      other_companies: [],
      selectedCompanyName: [],
    };
  },
  computed: {
    o_companies() {
      return this.other_companies;
    },
    mediaUrl() {
      return Api.MEDIA_URL || '';
    }
  },
  watch: {
    selectAllCompaniesModel(check) {
      if (check) this.selectAllCompanies();
      else this.unselectAllcompanies();
    },
  },
  methods: {
    shareCompanyResponse(result) {
      if (result) {
        this.afterVerify();
      } 
      this.$refs.confirmModal.hide();
    },
    handleExitWithoutSelection() {
      this.$router.push('/company-registration-complete');
    },
    hideModal() {
      this.selectedCompanyName = [];
    },
    async exitWithoutSelection() {
      await swal({
        title: '企業が選択されていません。',
        text: '',
        icon: 'warning',
        className: '',
        button: {
          text: '戻る',
          value: false,
          visible: true,
          closeModal: true,
        },
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async confirm() {
      this.scrollToTop();
      if (this.other_companies.length > 0) {
        this.other_companies.forEach((comp, index) => {
          const resultedCompany = this.companies.find(com => com._id === comp);
          this.selectedCompanyName.push(`${index + 1}. ${resultedCompany.name}`);
        }, this);
        this.$refs.confirmModal.show();
      } else {
        await this.exitWithoutSelection();
      }
    },
    async afterVerify() {
      try {
        await this.axios({
          method: 'post',
          data: {
            token: this.token,
            id: this.userId,
            other_companies: this.o_companies,
            first_time_registration: true,
          },
          url: Api.url(`${Api.endpoints.afterVerifyEmail}?selectAll=${this.selectAllCompaniesModel}`),
        });
        // Navigate to company registration complete page instead of showing swal
        this.$router.push('/company-registration-complete');
      } catch (error) {
        if (error.response.status === 400) {
          await swal({
            text: 'このリンクは期限切れか無効になっています。',
            icon: 'warning',
            buttons: {
              ok: 'はい',
            },
          });
          this.$emit('redirect', 'login');
        } else if (error.response.status === 503) {
          this.$emit('redirect', 'logout');
        }
      }
    },
    selectAllCompanies() {
      this.other_companies = this.companies.map(company => company._id);
    },
    unselectAllcompanies() {
      this.other_companies = [];
    },
    urlify(description) {
      const urlRegex = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w\-]*)?(\?[^\s]*)?/gi;
      return description.replace(urlRegex, url => `<a href="${url}" target="_blank">${url}</a>`);
    },
  },
};
</script>

<style scoped>
/* Remove modal body padding */
::v-deep .modal-body {
  padding: 0 !important;
}

::v-deep .modal {
  padding-left: 0px !important;
}

/* Remove modal content padding if needed */
::v-deep .modal-content {
  border-radius: 0;
}
.notice-list-header{
  color:#ff0000;
  margin-top: 12px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}
.notice-list{
  margin-left: -20px;
  line-height: 15px;
  color:#3c3c3c;
}
.mobile {
  display: none !important;
}

.font-16 {
  font-size: 16px;
}

.font-14 {
  font-size: 14px;
}

.swal-font {
  font-size: 20px;
}

.font-bold {
  font-weight: bold;
}

.companiesList {
  width: 75%;
}

@media (max-width: 991px) {
  .companiesList {
    width: 100%;
  }
}

.text-gray {
  color: gray;
}

.custom-btn {
  font-size: 14px;
  font-weight: bold;
}

.cancelBtn {
  background: #666666;
  border: 1px solid #666666;
}

.cancelBtn:hover {
  background: #494949 !important;
}

.confirmBtn {
  background: #ff0000;
  border: 1px solid #ff0000;
}

.confirmBtn:hover {
  background: #c20101 !important;
}

.w-230 {
  width: 230px;
}

/* Remove modal body padding globally */
>>> .modal-body {
  padding: 0 !important;
}

>>> .custom-checkbox {
  width: 20px;
  height: 20px;
}

@media (max-width: 550px) {
  .full {
    display: none !important;
  }
  .mobile {
    display: block !important;
    text-align: center;
  }
  .notice-list-header{
    font-size: 22px;
  }
  .custom-btn{
    font-size: 18px !important;
  }
  .swal-title{
    font-size:18px;
  }

  .swal-font{
    font-size: 14px;
  }

  >>> .modal-body{
    padding: 0 !important;
  }
  .swal-content{
    padding: 10px 0px 10px 0px;
  }
  .notice-list{
    font-size: 10px
  }
}

@media (max-width: 577px) {
  .stickyFooter > div {
    flex-direction: column-reverse !important;
    align-items: center;
  }

  >>> .custom-modal-footer-mobile {
    flex-direction: column !important;
    align-items: center;
  }

  .stickyFooter > div > button:nth-child(1),
  >>> .custom-modal-footer-mobile > button:nth-child(1) {
    margin-bottom: 0.5rem !important;
  }
}
</style> 